export function snakeToCamel(str) {
  return str.replace(/_([a-z])/g, (match, char) => char.toUpperCase());
}

export function convertKeysToCamelCase(obj) {
  if (Array.isArray(obj)) return obj.map(convertKeysToCamelCase);
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, val]) => [
        snakeToCamel(key),
        convertKeysToCamelCase(val),
      ])
    );
  }
  return obj;
}
